/**
 * Security History
 */

// React
import React, { useContext, useEffect, useState } from 'react';
import { Link, useParams, withRouter } from 'react-router-dom';

// Aryan's path
import { makeStyles, Theme, useTheme } from '@material-ui/core/styles';
import {
  useQuery,
  useMutation,
  useQueryClient,
  QueryClient,
  QueryClientProvider,
} from 'react-query';
import SwipeableViews from 'react-swipeable-views';

import { ReactQueryDevtools } from 'react-query/devtools';

// UI
import { createStyles, createTheme } from '@material-ui/core/styles';
import clsx from 'clsx';
import {
  ListItem,
  Collapse,
  ListItemIcon,
  ListItemText,
  Drawer,
  Divider,
  List,
  Avatar,
  DialogTitle,
  DialogActions,
  Dialog,
  Button,
  IconButton,
  Container,
  Box,
  Grid,
  Typography,
  AppBar,
} from '@material-ui/core';

// import {TabPanel} from '@material-ui/lab';
// Icon
import Icon from '@mdi/react';
import { mdiHome, mdiFilter, mdiClose } from '@mdi/js';
import { DriverCard } from '../components/driverCard';
import getVehiclesHistory from '../requests/getVehicleshistory';
import { FilterForm } from '../components/filters';
import { EntrancesHistoryMobView } from '../components/entrancesHistoryMobView';
import getHistoryByFilters from '../requests/getHistoryByFilters';
// Component

// Type

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    driverCard: {
      marginTop: '56px',
    },
    buttonOverflow: {
      position: 'relative',
      minWidth: '100vw',
    },
    driverMobView: {
      paddingLeft: '0px',
    },
    filterButton: {
      position: 'fixed',
      bottom: '0',
      left: '0',
      width: '100%',
      backgroundColor: '#F2F2F2',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    iconButtonBackground: {
      width: '100%',
      borderRadius: '0',
    },
    bottomNav: {},
    badgeFullWidth: {
      position: 'fixed',
      bottom: 0,
      paddingBottom: '8px',
      backgroundColor: 'black',
      minWidth: '100%',
      justifyContent: 'center',
    },
    root: {
      minWidth: '100%',
    },
    card: {
      backgroundColor: '#ffffff',
      borderStyle: 'groove',
      display: 'flex',
      border: '1px solid #E4E4E4',
    },
    iconLabel: {
      textAlign: 'center',
      fontSize: '16px',
    },
    iconRoutes: {
      padding: '8px',
      borderRadius: '0',
    },
    topText: {
      color: '#2f4858',
      fontSize: '16px',
    },
    icon: {
      color: '#fff',
    },

    toggleHolder: {
      height: '129px',
    },

    hideList: {
      display: 'none',
    },
    activePro: {
      '&:hover': {
        backgroundColor: '#DFA02E  !important',
      },
      textDecoration: 'none',
      backgroundColor: '#DFA02E',
    },
    item: {
      color: 'inherit',
      textDecoration: 'none',
    },
    sidebar: {
      // position: 'relative',
      transition: theme.transitions.create('all', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      '@media (max-width: 768px)': {
        position: 'fixed',
        transform: 'translate(-100%, -100%)',
        zIndex: '9',
      },
    },
    sidebarOpenMob: {
      '@media (max-width: 768px)': {
        transform: 'none',
      },
    },
    sidebarCloseMob: {
      '@media (max-width: 768px)': {
        transform: 'translate(-100%, -100%)',
      },
    },
    drawer: {
      marginTop: '40px',
      marginBottom: '70px',
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: 'nowrap',
    },
    drawerOpen: {
      width: drawerWidth,
      // overflowX: 'hidden',
      overflow: 'visible',
      background: theme.palette.primary.main,
      color: '#fff',
      // transition: theme.transitions.create('width', {
      //   easing: theme.transitions.easing.sharp,
      //   duration: theme.transitions.duration.enteringScreen,
      // }),
    },
    drawerClose: {
      // transition: theme.transitions.create('width', {
      //   easing: theme.transitions.easing.sharp,
      //   duration: theme.transitions.duration.enteringScreen,
      // }),

      marginBottom: '7px',
      overflowX: 'hidden',
      // overflow: 'visible',
      width: theme.spacing(8) + 1,
      [theme.breakpoints.up('sm')]: {
        width: theme.spacing(9) + 1,
      },
      background: theme.palette.primary.main,
      color: '#fff',
    },
    appBar: {
      padding: '8px 12px',
      backgroundColor: '#ffffff',
      zIndex: theme.zIndex.drawer + 1,
      boxShadow: 'none',
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: `calc(100 % -${drawerWidth} px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: 36,
    },
    hide: {
      display: 'none',
    },

    nested: {
      '& > span': {
        paddingLeft: theme.spacing(7),
        fontSize: '14px !important',
      },
    },
    avatar: {
      margin: theme.spacing(6, 'auto', 7),
      height: '70px !important',
      // transition: theme.transitions.create('all', {
      //   easing: theme.transitions.easing.sharp,
      //   duration: theme.transitions.duration.enteringScreen,
      // }),
    },
    avatarLarg: {
      width: '148px',
      height: theme.spacing(15),
    },

    avatarSmall: {
      // marginTop: '54px',
      width: theme.spacing(5),
      height: theme.spacing(5),
    },
    avatarMob: {
      // marginTop: '54px',
      width: theme.spacing(0),
      height: theme.spacing(0),
    },
    userInfoContainer: {
      marginTop: 'auto',
      alignItems: 'center',
    },
    userInfoBox: {
      display: 'flex',
      alignItems: 'center',
      padding: '8px 16px',
      marginRight: '5px',
    },
    userInfoIconBox: {
      backgroundColor: '#345163',
      borderRadius: '4px',
      display: 'flex',
      // marginLeft: '5px',
    },
    userAvatar: {
      backgroundColor: '#345163',
      width: '43px',
      height: '43px',
    },
    username: {
      padding: theme.spacing(0, 1),
      fontSize: '16px',
      fontWeight: 500,
    },
    toolbar: {
      display: 'flex',
      position: 'relative',
      top: 0,
      backgroundColor: theme.palette.primary.main,
      // backgroundColor: 'red',
      zIndex: 20,

      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: theme.spacing(0, 1),
      transition: theme.transitions.create(['all'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    toolbarOpen: {
      width: drawerWidth,
      alignItems: 'flex-start',
      transition: theme.transitions.create(['all'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      // transition: 'all .2s',
    },
    toolbarClose: {
      width: '73px',
      transition: theme.transitions.create(['all'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    toolbarCircle: {
      textAlign: 'center',
      display: 'flex',
      backgroundColor: theme.palette.background.default,
      borderRadius: '50%',
      width: '100%',
      height: '100%',
      '@media (max-width: 768px)': {},
    },
    toolbarCircleSecound: {
      backgroundColor: theme.palette.secondary.main,
      borderRadius: '50%',
      width: '50px',
      height: '50px',
      margin: 'auto',
      '@media (max-width: 768px)': {},
    },
    divider: {
      backgroundColor: '#fff',
      margin: '0 16px',
    },
    mobMenu: {
      display: 'none',
      '@media (max-width: 768px)': {
        position: 'fixed',
        top: '0',
        right: '0',
        left: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        height: '64px',
        backgroundColor: theme.palette.primary.main,
        padding: '20px',
        zIndex: '10',
      },
    },
  })
);

// const useStyles = makeStyles((theme: Theme) => ({
//   root: {
//     backgroundColor: theme.palette.background.paper,
//     width: 500,
//   },
// }));

// Const
const drawerWidth = 231;

const queryClient = new QueryClient();

export default function TrafficHistory(props: any) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AppBar className={classes.appBar}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography className={classes.topText} variant="h6">
              پنل حراست
            </Typography>
          </Grid>
          <Grid item>
            <Link to="/security/">
              <IconButton>
                <Icon path={mdiHome} size={1} />
              </IconButton>
            </Link>
          </Grid>
        </Grid>
      </AppBar>
      <QueryClientProvider client={queryClient}>
        <FiltersElement />
        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      </QueryClientProvider>
    </div>
  );
}

export const FiltersElement = (props: {}) => {
  const classes = useStyles();
  const [openFilterModal, setOpenFilterModal] = useState(false);

  const [filterParams, setFilterParams] = useState<any>();


  const passFiltersThrough = (filters: any | undefined) => {
    setFilterParams(filters);
    setOpenFilterModal(false)
  };

  return (
    <React.Fragment>
      <AppBar className={classes.appBar}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography className={classes.topText} variant="h6">
              فیلتر
            </Typography>
          </Grid>
          <Grid item>
            {openFilterModal ? <IconButton onClick={() => setOpenFilterModal(false)}>
              <Icon path={mdiClose} size={1} />
            </IconButton> : <Link to="/security/">
              <IconButton>
                <Icon path={mdiHome} size={1} />
              </IconButton>
            </Link>}
          </Grid>
        </Grid>
      </AppBar>
      {openFilterModal ? <FilterForm
        open={openFilterModal}
        onClose={() => setOpenFilterModal(false)}
        onSubmit={passFiltersThrough}
      /> : <div style={{ marginBottom: "50px" }}>
        <QueryClientProvider client={queryClient}>
          <EntrancesHistoryMobView filtersDrill={filterParams} />
        </QueryClientProvider>
      </div>}
      <Grid container xs={12}>
        <div className={classes.filterButton}>
          <IconButton
            className={classes.iconButtonBackground}
            onClick={() => setOpenFilterModal(true)}
          >
            <Icon path={mdiFilter} size={1} />
            <Typography>فیلتر</Typography>
          </IconButton>
        </div>
      </Grid>
    </React.Fragment>
  );
};
